import React, { useContext } from "react";

import { Grid, Grow } from "@material-ui/core";

import Card from "../../../../components/cards/Card";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import { ParametrosProdutoContext } from "../contexts/ParametrosProdutoContext";

import { Margin } from "../styles/Emissao";
import useEmissaoController from "../controllers/EmissaoController";

const TabEmissaoCombustivel = ({ ...prop }) => {
  const {
    productFuelCodeAnp,
    setProductFuelCodeAnp,
    productFuelDescAnp,
    setProductFuelDescAnp,
    productFuelUf,
    setProductFuelUf,
    productFuelGlpPetroleum,
    setProductFuelGlpPetroleum,
    productFuelNationalGas,
    setProductFuelNationalGas,
    productFuelImportedGas,
    setProductFuelImportedGas,
    productFuelValueWithoutICMS,
    setProductFuelValueWithoutICMS,
    loading,
  } = useContext(ParametrosProdutoContext);

  const { handleCodeAnp } = useEmissaoController();

  return (
    <Grid container spacing={2}>
      <Grow in={true}>
        <Grid item lg={12} sm={12}>
          <Card line="left">
            <Margin top="10">
              <Grid container spacing={2}>
                <Grid item lg={2} sm={2}>
                  <TextFieldErp
                    label="Código ANP"
                    maxLength={60}
                    value={productFuelCodeAnp}
                    setValue={setProductFuelCodeAnp}
                    onBlur={() => {
                      handleCodeAnp(productFuelCodeAnp);
                    }}
                    type="number"
                  />
                </Grid>

                <Grid item lg={6} sm={6}>
                  <TextFieldErp
                    label="Descrição ANP"
                    maxLength={60}
                    value={productFuelDescAnp}
                    setValue={setProductFuelDescAnp}
                    loading={loading}
                  />
                </Grid>

                <Grid item lg={2} sm={3}>
                  <TextFieldErp
                    value={productFuelUf}
                    setValue={setProductFuelUf}
                    maxLength={2}
                    label="UF"
                    size="small"
                  />
                </Grid>

                <Grid item lg={3} sm={3}>
                  <TextFieldErp
                    label="% GLP Derivado do Petróleo"
                    maxLength={20}
                    value={productFuelGlpPetroleum}
                    setValue={setProductFuelGlpPetroleum}
                    mask="decimal"
                    decimals={4}
                  />
                </Grid>

                <Grid item lg={3} sm={3}>
                  <TextFieldErp
                    label="% Gás Natural Nacional"
                    maxLength={20}
                    value={productFuelNationalGas}
                    setValue={setProductFuelNationalGas}
                    mask="decimal"
                    decimals={4}
                  />
                </Grid>

                <Grid item lg={3} sm={3}>
                  <TextFieldErp
                    label="% Gás Natural Importado"
                    maxLength={20}
                    value={productFuelImportedGas}
                    setValue={setProductFuelImportedGas}
                    mask="decimal"
                    decimals={4}
                  />
                </Grid>

                <Grid item lg={3} sm={3}>
                  <TextFieldErp
                    label="Valor de partida Sem ICMS"
                    maxLength={20}
                    value={productFuelValueWithoutICMS}
                    setValue={setProductFuelValueWithoutICMS}
                    mask="decimal"
                    decimals={4}
                  />
                </Grid>
              </Grid>
            </Margin>
          </Card>
        </Grid>
      </Grow>
    </Grid>
  );
};

export default TabEmissaoCombustivel;
